/**
 * Extrae el mensaje real de error devuelto por una Edge Function.
 * supabase.functions.invoke devuelve "Edge Function returned a non-2xx status code"
 * y deja la respuesta original en error.context.
 */
export async function getFunctionErrorMessage(
  error: any,
  fallback = "Error inesperado",
): Promise<string> {
  try {
    const res = error?.context;
    if (res && typeof res.json === "function") {
      const body = await res.clone().json();
      const msg = body?.error || body?.message;
      if (typeof msg === "string" && msg.trim()) return msg;
    } else if (res && typeof res.text === "function") {
      const text = await res.text();
      const body = JSON.parse(text);
      const msg = body?.error || body?.message;
      if (typeof msg === "string" && msg.trim()) return msg;
    }
  } catch {
    // ignore parse errors
  }
  return error?.message || fallback;
}
